import React from "react";
import { store } from "../../../../../redux/store";
import { heights } from "../../../../../styles/romeu/heights";
import { widths } from "../../../../../styles/romeu/widths";
import { MasterOriginalMerchandiseList } from "./list/list";
import { setMerchandiseOrigins } from "../../../../../redux/reducers/catalog/catalog";
import { resetMasterMerchandiseOriginList } from "../../../../../redux/reducers/resources/master/merchandiseOrigins/list";

export class MasterMerchandiseOriginContainer extends React.Component {
    componentWillUnmount(): void {
        store.dispatch(resetMasterMerchandiseOriginList());
        store.dispatch(setMerchandiseOrigins([]));
    }

    render(): React.ReactNode {
        return (
            <MasterOriginalMerchandiseList
                widthPopUp={widths.master.default}
                heigthPopUp={heights.master.default}
            />
        );
    }
}
